import { constantCreator } from '~/utils/constantsCreator';
import { convertToDestinationArray } from '~/utils/trip';
import api from '~/utils/api';

// import experienceDestinations from '~/experience-destinations.json';
import siteConfigs from '~/site-configs.json';
import activities from '~/activities.json';
import languages from '~/languages.json';
import destinations from '~/destinations.json';


const constant = constantCreator('info');
export const LOAD_COMBINED_DYNAMIC = constant('LOAD_COMBINED_DYNAMIC', true);
const LOAD_COMBINED_STATIC = constant('LOAD_COMBINED_STATIC', true);
const GET_EBOOK_INFO = constant('GET_EBOOK_INFO', true);
const SUBMIT_EBOOK_FORM = constant('SUBMIT_EBOOK_FORM', true);
const SUBMIT_CUSTOMIZE_REQUEST_CAR_RENTAL = constant('SUBMIT_CUSTOMIZE_REQUEST_CAR_RENTAL', true);

const initialState = {
  destinations: {},
  exchangeRates: {},
  stations: {},
  stationsLoaded: false,
  arlLoaded: false,
  mrtLoaded: false,
  btsLoaded: false,
  exchangeRatesLoaded: false,
  destinationsLoaded: false,
  activeLanguages: [],
  activeLanguagesLoaded: false,
  activitiesLoaded: false,
  userConfigLoaded: false,
  activities: [],
  forms: [],
  formsLoaded: false,
  userConfig: {},
  siteConfigs: {
    removeSearchFeature: false,
    tripHideLx: false,
  },
  headTags: {},
  headTagsLoaded: false,
  topActivities: [],
  topActivitiesLoaded: false,
  combinedStaticLoaded: false,
  presetActivities: [],
  presetActivitiesLoaded: false,
  combinedDynamicLoaded: false,
  ebooks: [],
  ebooksLoadded: false,
  ebookError: null,
  submittingEbookForm: false,
  ebookFormSubmitted: false,
  customizeCarRentalError: ''
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case LOAD_COMBINED_DYNAMIC.RESOLVED:
      return {
        ...state,
        userConfig: action.data.userConfigs,
        userConfigLoaded: true,
        combinedDynamicLoaded: true,
      };
    case LOAD_COMBINED_STATIC.RESOLVED:
      return {
        ...state,
        // siteConfigs: action.data.siteConfigs,
        siteConfigs,
        siteConfigsLoaded: true,
        // destinations: convertToDestinationArray(action.data.destinations),
        destinations: convertToDestinationArray(destinations),
        destinationsLoaded: true,
        // exchangeRates: action.data.exchangeRates,
        exchangeRates: action.data.exchangeRates.rates,
        exchangeRatesLoaded: true,
        // activeLanguages: ['Any', ...action.data.languages],
        activeLanguages: ['Any', languages],
        activeLanguagesLoaded: true,
        // activities: action.data.activities,
        activities,
        activitiesLoaded: true,
        // headTags: action.data.headTags || {},
        headTags: action.data.headTags || {},
        headTagsLoaded: true,
        combinedStaticLoaded: true,
      };
    case GET_EBOOK_INFO.RESOLVED:
      return {
        ...state,
        ebooks: action.data,
        ebooksLoadded: true
      };
    case GET_EBOOK_INFO.REJECTED:
      return {
        ...state,
        ebookError: action.error,
        ebooksLoadded: true
      };
    case SUBMIT_EBOOK_FORM.PENDING:
      return {
        ...state,
        submittingEbookForm: true
      };
    case SUBMIT_EBOOK_FORM.RESOLVED:
      return {
        ...state,
        submittingEbookForm: false,
        ebookFormSubmitted: true
      };
    case SUBMIT_EBOOK_FORM.REJECTED:
      return {
        ...state,
        submittingEbookForm: false,
      };
    case SUBMIT_CUSTOMIZE_REQUEST_CAR_RENTAL.PENDING:
    case SUBMIT_CUSTOMIZE_REQUEST_CAR_RENTAL.RESOLVED:
      return {
        ...state,
        customizeCarRentalError: ''
      };
    case SUBMIT_CUSTOMIZE_REQUEST_CAR_RENTAL.REJECTED:
      return {
        ...state,
        customizeCarRentalError: action.error
      };
    default:
      return state;
  }
};

export const actions = {
  loadCombinedDynamic: () => ({
    type: LOAD_COMBINED_DYNAMIC,
    promise: api.get('/combined/dynamic')
  }),
  loadCombinedStatic: () => ({
    type: LOAD_COMBINED_STATIC,
    promise: api.get('/configs?keys=exchangeRates'),
  }),
  // loadCombinedStatic: () => ({
  //   type: LOAD_COMBINED_STATIC,
  //   promise: api.get('/combined/static'),
  // }),
  getEbooks: () => ({
    type: GET_EBOOK_INFO,
    promise: api.get('/info/ebooks-info'),
  }),
  submitEbookForm: (data) => ({
    type: SUBMIT_EBOOK_FORM,
    promise: api.post('/info/download-ebook', {
      name: data.name,
      email: data.email,
      questions: data.questions,
      ebookName: data.ebookName,
      slug: data.slug
    })
  }),
  submitCustomizeCarRental: (data) => ({
    type: SUBMIT_CUSTOMIZE_REQUEST_CAR_RENTAL,
    promise: api.post('/customize/car-rental', data)
  })
};

export default reducer;
